import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingScreen() {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    minBlockSize: "100vh",
    "data-test-id": "loading-screen",
    "aria-busy": true,
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    })
  });
}
export default LoadingScreen;